import { render, staticRenderFns } from "./ClassicDashboard.vue?vue&type=template&id=5b32124a"
import script from "./ClassicDashboard.vue?vue&type=script&lang=js"
export * from "./ClassicDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClassicDashboard.vue?vue&type=style&index=0&id=5b32124a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports